export const categories = [
  {
    slug: 'huangwang-dingyi',
    name: '黄网定义',
    description: '了解什么是黄色网站，其特征与常见形态',
    icon: 'ri-information-line',
  },
  {
    slug: 'huangwang-weihai',
    name: '黄网危害',
    description: '深入了解黄网对个人、家庭和社会的严重危害',
    icon: 'ri-alert-line',
  },
  {
    slug: 'huangwang-shibie',
    name: '识别方法',
    description: '掌握识别黄网的实用技巧与方法',
    icon: 'ri-eye-line',
  },
  {
    slug: 'huangwang-falv',
    name: '法律风险',
    description: '了解浏览和传播黄网内容的法律后果',
    icon: 'ri-scales-line',
  },
  {
    slug: 'fangfan-cuoshi',
    name: '防范措施',
    description: '学习有效的黄网防范策略与技术手段',
    icon: 'ri-shield-check-line',
  },
  {
    slug: 'qingshaonian-baohu',
    name: '青少年保护',
    description: '保护青少年远离网络色情，营造健康上网环境',
    icon: 'ri-parent-line',
  },
];